import { render, staticRenderFns } from "./CoreFilesCard.vue?vue&type=template&id=6b9f966c"
import script from "./CoreFilesCard.vue?vue&type=script&lang=js"
export * from "./CoreFilesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports